export const PERIOD = 'period';
export const BUSINESS_PARTNER = 'businessPartnerId';
export const BUSINESS_PARTNER_VERSION = 'businessPartnerVersion';

// IOs
export const AFFILIATE = 'affiliate';
export const AFFILIATES = 'affiliates';
export const AFFECTED_IOS = 'affectedIOs';

export const BP_LEVEL = 0;
export const AFFILIATE_LEVEL = 1;

export const AGREEMENT = 'agreement';
export const AGREEMENT_TYPE = 'agreementType';
export const GO_GAME_ACCESS_PARAGRAPH = 'accessParagraphType';

export const GO_GAME_ACCESS_PARAGRAPH_EXCLUDED = 0;
export const ATTACHMENTS = 'attachments';

export const SIGNED_BY_PUBLISHER = 'signedByPublisher';

// Business Partner Contact Details
export const BUSINESS_PARTNER_CONTACT_DETAILS = 'businessPartnerContactDetails';
export const DESCRIPTION = 'description';

// Payment Terms
export const PAYMENT_TERMS = 'paymentTerms';
export const PAYMENT_TERMS_ID = 'paymentTermsId';
export const EXPENSE_TYPE = 'expenseType';
export const TRAFFIC_RESTRICTIONS = 'trafficRestrictions';
export const INVOICE_REQUIREMENTS = 'invoiceRequirements';
export const ADDITIONAL_INVOICE_REQUIREMENTS = 'additionalInvoiceRequirements';
export const CONVERSIONS_APPROVAL_COMMENT = 'conversionsApprovalComment';

// Business Partner Payment Details
export const PAYMENT_DETAILS = 'paymentDetails';
export const BANK_NAME = 'bankName';
export const BANK_ADDRESS = 'bankAddress';
export const ACCOUNT_NUMBER = 'accountNumber';
export const ACCOUNT_NAME = 'accountName';
export const IBAN = 'iban';
export const SWIFT_CODE = 'swiftCode';

// Legal Contact Person
export const LEGAL_CONTACT = 'legalContact';
export const FIRST_NAME = 'firstName';
export const LAST_NAME = 'lastName';
export const IM_ADDRESS = 'imAddress';
export const PHONE = 'phone';
export const EMAIL = 'email';

export const BUDGET = 'budget';
export const AMOUNT = 'amount';
export const CURRENCY_CODE = 'currencyCode';
export const MONTHLY = 'monthly';
export const RATE_OF_NET = 'rateOfNet';
export const BP_EMAIL = 'bpEmail';
export const ATTACHMENT_TYPE = {
  Agreement: 1,
  FrameAgreement: 2,
  Io: 3,
  AgreementWithIo: 4,
};

export const DEPENDENCIES = {
  [BUSINESS_PARTNER_VERSION]: [BUSINESS_PARTNER],
  [AFFECTED_IOS]: [PERIOD, BUSINESS_PARTNER_VERSION],
  [AFFILIATE]: [BUSINESS_PARTNER],
  [AFFILIATES]: [BUSINESS_PARTNER],
  [BUDGET]: [PERIOD, `${BUDGET}.${AMOUNT}`, `${BUDGET}.${CURRENCY_CODE}`],
  [`${BUDGET}.${MONTHLY}`]: [PERIOD],
  [`${BUDGET}.${CURRENCY_CODE}`]: [BUSINESS_PARTNER, BUSINESS_PARTNER_VERSION],
  [`${PAYMENT_TERMS}.${EXPENSE_TYPE}`]: [
    BUSINESS_PARTNER,
    BUSINESS_PARTNER_VERSION,
  ],
  [`${PAYMENT_TERMS}.${TRAFFIC_RESTRICTIONS}`]: [
    BUSINESS_PARTNER,
    BUSINESS_PARTNER_VERSION,
  ],
  [BUSINESS_PARTNER_CONTACT_DETAILS]: [
    BUSINESS_PARTNER,
    BUSINESS_PARTNER_VERSION,
  ],
};

// PERMISSIONS
export const PERMISSION_PERIOD = 'period';
export const PERMISSION_BUSINESS_ENTITY = 'businessEntity';
export const PERMISSION_AFFECTED_IOS = 'affectedIOs';
export const PERMISSION_AGREEMENT = 'agreement';
export const PERMISSION_DESCRIPTION = 'description';
export const PERMISSION_PAYMENT_TERMS = 'paymentTerms';
export const PERMISSION_BUDGET = 'budget';
export const PERMISSION_BUSINESS_PARTNER_CONTACT_DETAILS =
  'businessPartnerContactDetails';
export const PERMISSION_PAYMENT_DETAILS = 'paymentDetails';
export const PERMISSION_LEGAL_CONTACT = 'legalContact';

export const PERMISSIONS = {
  all: [
    PERMISSION_PERIOD,
    PERMISSION_BUSINESS_ENTITY,
    PERMISSION_AFFECTED_IOS,
    PERMISSION_AGREEMENT,
    PERMISSION_DESCRIPTION,
    PERMISSION_PAYMENT_TERMS,
    PERMISSION_BUDGET,
    PERMISSION_BUSINESS_PARTNER_CONTACT_DETAILS,
    PERMISSION_PAYMENT_DETAILS,
    PERMISSION_LEGAL_CONTACT,
  ],
  amendment: [
    PERMISSION_PERIOD,
    PERMISSION_AGREEMENT,
    PERMISSION_BUDGET,
    PERMISSION_LEGAL_CONTACT,
  ],
};
